"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RejectStatementDialog',
  data: function data() {
    return {
      visible: false,
      submitLoading: false,
      form: {
        id: '',
        rejectReason: ''
      },
      rules: {
        rejectReason: [{
          required: true,
          message: '请输入驳回原因',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    open: function open(row) {
      this.form = {
        id: row.id,
        rejectReason: ''
      };
      this.visible = true;
    },
    handleClosed: function handleClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.submitLoading = false;
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this.submitLoading = true;
        statementApi.statementRejectApi({
          id: _this.form.id,
          rejectReason: _this.form.rejectReason
        }).then(function () {
          _this.$message.success('驳回成功');
          _this.visible = false;
          _this.$emit('refresh');
        }).catch(function () {}).finally(function () {
          _this.submitLoading = false;
        });
      });
    }
  }
};